export default __webpack_public_path__ + "static/media/cab_red_acre02-2.02822545.PNG";